import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Tabs, Spin } from "antd";
import EditSellerDetails from "./editSellerDetails";
import ProductList from "./ProductList";
import UploadProducts from "./uploadProducts";
import axios from "axios";
import SummaryApi from "../../../common/index";

const { TabPane } = Tabs;

const SellerView = () => {
  const { sellerId } = useParams();
  const [seller, setSeller] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("product-list");
  const [editProduct, setEditProduct] = useState(null);
  const [refreshProducts, setRefreshProducts] = useState(false);

  const fetchSeller = async () => {


    try {
      setLoading(true);
      const token = localStorage.getItem("adminToken");
      const res = await axios.get(`${SummaryApi.getAllSellers.url}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.success) {
        const selected = res.data.data.find((s) => s.id.toString() === sellerId);
        setSeller(selected || null);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSeller();
  }, [sellerId]);

  
const handleEditProduct = (product) => {
  setEditProduct(product);
    console.log("EDIT PRODUCT:", product);       // set initial values
  setActiveTab("upload-product"); // switch to Upload Product tab
};
  if (loading) return <Spin style={{ display: "block", margin: "50px auto" }} />;
  if (!seller) return <div>Select a valid seller to edit</div>;

  return (
    <Tabs activeKey={activeTab} type="card" onChange={(key) => setActiveTab(key)} defaultActiveKey="edit-details" >
      <TabPane tab="Edit Details" key="edit-details">
        <EditSellerDetails seller={seller} refreshSeller={fetchSeller} />
      </TabPane>
      <TabPane tab="Product List" key="product-list">
        <ProductList sellerId={sellerId} 
        onEdit={handleEditProduct}
         setActiveTab={setActiveTab}     // allow ProductList to switch tabs
          setEditProduct={setEditProduct} 
          refresh={refreshProducts}/>
             
      </TabPane>
      <TabPane tab="Upload Product" key="upload-product">
         {activeTab === "upload-product" && (
    <UploadProducts
      token={localStorage.getItem("adminToken")}
      editMode={!!editProduct}      // true if editing a product
      initialValues={editProduct || {}} // prefill form
      onSuccess={() => {
        setEditProduct(null);      // clear edit state
          setRefreshProducts((p) => !p);   // FORCE RELOAD
  setActiveTab("product-list"); // go back to product list
      }}
      sellerId={sellerId}          // pass seller id for upload
    />
  )}
      </TabPane>
    </Tabs>
  );
};

export default SellerView;
